import type { AsyncDataRequestStatus, NuxtError } from '#app';
import type { Ref } from 'vue';

export const useErrorWatcher = (
    status: Ref<AsyncDataRequestStatus>,
    error: Ref<NuxtError<unknown> | null>,
    options: Ref<any | null>,
    onError: Function | null) => {
    //const { $client } = useNuxtApp();
    //const { page } = storeToRefs($client);

    const router = useRouter();

    watch([status, router.currentRoute], async ([s, route]) => {
        if (status.value === 'error' /*&& route.fullPath === options.value.to.fullPath*/) {
            await onError();

            throw showError({
                statusCode: error.value?.statusCode || 500,
                statusMessage: error.value?.statusMessage || 'Oops, something went wrong!',
                message: error.value?.message || 'Internal server error',
                data: {
                    referer: options.value.from?.fullPath !== options.value.to?.fullPath
                        ? options.value.from?.fullPath
                        : null,
                    ...error.value.cause?.data
                },
                fatal: true
            } as NuxtError);
        }
    })
}